import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-8">
        <div className="py-14 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 text-sm font-bold">法</span>
              <span className="font-heading font-semibold text-sm text-background-50">强奸罪法律解析与辩护指南</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              专业刑事辩护律师团队，致力于为当事人提供全面、专业的法律解析与辩护策略指导，维护每一位当事人的合法权益。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <Link to="/category/legal-definition" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">法律定义</Link>
              </li>
              <li>
                <Link to="/category/defense" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">辩护策略</Link>
              </li>
              <li>
                <Link to="/category/sentencing" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">量刑标准</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-phone-line text-background-50/40 mt-0.5"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line text-background-50/40 mt-0.5"></i>
                <span>contact@criminaldefense.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line text-background-50/40 mt-0.5"></i>
                <span>北京市朝阳区建国路88号SOHO现代城A座12层</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-5 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 强奸罪法律解析与辩护指南. 本站内容仅供法律信息参考，不构成法律意见。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>隐私政策</span>
            <span>使用条款</span>
            <span>免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}